import React from 'react';
import { useRomaneio } from '../../hooks/useRomaneio';
import Separator from '~/components/Separator';
import {
  InputMoney,
  InputNumber,
  InputSelect,
  InputText,
} from '~/components/NovosInputs';
import { selectTipoAjusteProps } from '../../types';

export const AjusteFields: React.FC = () => {
  const {
    formTela,
    flgCancelado,
    tiposAjuste,
    handleFocus,
    refetchTiposAjuste,
    disabledInputs,
    unidades,
  } = useRomaneio();
  const {
    register,
    control,
    formState: { errors },
    setValue,
    clearErrors,
  } = formTela;
  return (
    <>
      <Separator labelText="Dados do Ajuste" />
      <div className="d-flex flex-column gap-2">
        <div className="d-flex flex-row gap-4 align-items-end justify-content-between">
          <div style={{ maxWidth: '700px', flex: 1 }}>
            <InputSelect
              label="Ajuste *"
              placeholder="Selecione um ajuste"
              name="cod_tipo_ajuste"
              register={register}
              control={control}
              options={tiposAjuste}
              isError={!!errors.cod_tipo_ajuste}
              disabled={disabledInputs.ajuste}
              onBlur={refetchTiposAjuste}
              changeSelected={(selected: selectTipoAjusteProps) => {
                clearErrors('cod_tipo_ajuste');
                setValue('cod_tipo_ajuste', selected);
                handleFocus('qtd_ajuste');
              }}
            />
          </div>

          {flgCancelado && (
            <div
              style={{
                display: 'flex',
                minWidth: '200px',
                maxHeight: '50px',
                color: '#e63c3c',
                padding: '5px 10px 0px 10px',
                textAlign: 'center',
                backgroundColor: 'yellow',
                justifyContent: 'center',
              }}
            >
              <h2>CANCELADO</h2>
            </div>
          )}
        </div>

        <div className="d-flex flex-row gap-4">
          <div className="qtd">
            <InputNumber
              name="qtd_ajuste"
              label="Quantidade *"
              placeholder="0"
              register={register}
              control={control}
              isError={!!errors.qtd_ajuste}
              disabled={disabledInputs.qtd}
              min={0}
              max={99999999999}
              maxLength={11}
            />
          </div>

          <div className="un">
            <InputSelect
              label="Un: *"
              placeholder="Selecione uma Unidade"
              name="des_un"
              register={register}
              control={control}
              options={unidades}
              isError={!!errors.cod_tipo_ajuste}
              disabled={disabledInputs.un}
              changeSelected={(selected) => {
                clearErrors('des_un');
                setValue('des_un', selected);
                handleFocus('des_emb');
              }}
            />
          </div>

          <div className="emb">
            <InputNumber
              name="des_emb"
              label="Emb: *"
              placeholder="0"
              register={register}
              control={control}
              isError={!!errors.des_emb}
              disabled={disabledInputs.emb}
              min={0}
              max={9999}
              maxLength={5}
            />
          </div>

          <div className="val-custo">
            <InputMoney
              name="val_custo_unit"
              label="Custo Unit. *"
              placeholder="0,00"
              register={register}
              control={control}
              isError={!!errors.val_custo_unit}
              disabled={disabledInputs.val_custo}
              min={0}
              max={999999999999}
              maxLength={13}
            />
          </div>

          <div className="num-doc">
            <InputText
              name="num_docto"
              label="Docto."
              placeholder=""
              register={register}
              control={control}
              caseInput="upper"
              alignRight
              disabled={disabledInputs.docto}
              isError={!!errors.num_docto}
              maxLength={50}
            />
          </div>
        </div>
      </div>
    </>
  );
};
